import { httpService } from '../../../../../../../../../services/http.service';
import bugsnagHandler from '../../../../../../../../../services/bugsnag.service';
import { BASE_URL } from '../../../../../../../../../constants/endpoints';

export const markBillAsCanceledAPIAction = async (customerId: string, accountExternalId: string, billId: string) => {
  if (!customerId || !accountExternalId || !billId) {
    bugsnagHandler.notify(`Bill Pay - Bills Hub - Mark as Cancel Action - Missing customerId (${customerId}), accountExternalId (${accountExternalId}) or billId (${billId})`);
    return false;
  }
  try {
    const { data } = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${billId}/cancel`);
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Bill Pay - Bills Hub - Mark as Cancel Action - error canceling a bill', e);
    throw e;
  }
};
